import "../styles/App.css";
import LinkedIn from "../images/LinkedIn.png";
import Git from "../images/git.png";
import Facebook from "../images/fb.png";
import React from "react";

class SocialMedia extends React.Component {
	render() {
		return (
			<div className="SocialMedia">
				<div>
					<a
						href="https://www.linkedin.com/in/mateusz-cisło-01716b196"
						target="_blank"
					>
						<img src={LinkedIn} alt="alt"></img>
					</a>
				</div>
				<div>
					<a href="https://github.com/emceDev" target="_blank">
						<img src={Git} alt="alt"></img>
					</a>
				</div>
			</div>
		);
	}
}

export default SocialMedia;



// WEBPACK FOOTER //
// ./src/components/SocialMedia.js